<template>
  <a-modal v-model="modal" title="选订单叫料" width="90%" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <ls-table-layout>
      <div class="table-page-search-wrapper" slot="search">
        <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
          <a-input slot="itemCode" v-decorator="['itemCode', { rules: [{ required: true, message: '物料编码不能为空' }] }]" />
        </ls-search-form>
      </div>
      <template v-slot:table>
        <div class="page-header-content">
          <a-form-model ref="baseForm" class="baseForm" :model="formData">
            <ls-metable
              class="orderMaterialTable"
              :columns="columns"
              :data-list="formData.infos"
              :scroll="{y:400, x:1600}"
              :customRow="(record, index) => index"
              rowKey="key_id"
              size="middle"
              :loading="tableLoading"
              :IsEdit="false"
              :needAdd="false"
            >
              <!--叫料量-->
              <template slot="callQty" slot-scope="{text,record,index}">
                <a-form-model-item
                  :prop="`infos.${index}.callQty`">
                  <a-input-number
                    v-model="record.callQty"
                    :min="0"
                    :max="Number(record.canCallQty || 0)"
                    :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                    :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')" />
                </a-form-model-item>
              </template>
              <!--叫料期望交货日期-->
              <template slot="callExpectedDeliveryDate" slot-scope="{text,record,index}">
                <a-form-model-item
                  :prop="`infos.${index}.callExpectedDeliveryDate`">
                  <a-date-picker style="width: 100%" v-model="record.callExpectedDeliveryDate" valueFormat="YYYY-MM-DD" :disabledDate="disabledDate"/>
                </a-form-model-item>
              </template>
            </ls-metable>
          </a-form-model>
        </div>
      </template>
    </ls-table-layout>
    <template #footer>
      <a-space>
        <a-button @click="onClose">取消</a-button>
        <a-button type="primary" @click="onSubmit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import { apiMesQueryTradeOrderCreate, apiMesQueryTradeOrderFromScmSingle } from '@/api/scp/purchase/purchaseApi'

export default {
  name: 'PurchaseOrderAddModal',
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data() {
    return {
      organizationCode: '', // 加工厂
      modal: false,
      // 查询参数
      queryParams: {
        itemCode: undefined,
        tradeOrder: undefined,
        orderExpectedDeliveryDate: undefined,
        orderExpectedDeliveryDateStart: undefined,
        orderExpectedDeliveryDateEnd: undefined
      },
      formData: { infos: [] },
      tableLoading: false, // table加载
      loading: false,
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      formList: [
        { label: '物料编码', decorator: ['itemCode'], type: 'itemCode' },
        { label: '交易订单号', decorator: ['tradeOrder'], type: 'input' },
        {
          label: '期望到货日期',
          type: 'range',
          decorator: ['orderExpectedDeliveryDate'],
          disposeFormat: {
            orderExpectedDeliveryDateStart: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            orderExpectedDeliveryDateEnd: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        }
      ],
      // 表格字段
      columns: [
        { title: '采购方', dataIndex: 'supplierName', width: 120, align: 'center' },
        { title: '销售方', dataIndex: 'factoryName', width: 120, align: 'center' },
        { title: '业务类型', dataIndex: 'businessType', width: 140, align: 'center' },
        { title: '交易单号', dataIndex: 'tradeOrder', width: 120, align: 'center' },
        { title: '采购数量', dataIndex: 'procurementQuantity', width: 120, align: 'center' },
        { title: '物料编码', dataIndex: 'itemCode', width: 80, align: 'center' },
        { title: '物料名称', dataIndex: 'itemName', width: 90, align: 'center' },
        { title: '规格描述', dataIndex: 'specificationDescription', width: 85, align: 'center' },
        {
          title: '订单期望交货日期',
          dataIndex: 'orderExpectedDeliveryDate',
          width: 85,
          align: 'center',
          customRender: (value, row) => row.orderExpectedDeliveryDate ? this.$moment(row.orderExpectedDeliveryDate).format('YYYY-MM-DD') : ''
        },
        {
          title: '叫料期望交货日期',
          dataIndex: 'callExpectedDeliveryDate',
          width: 120,
          scopedSlots: { customRender: 'callExpectedDeliveryDate' },
          align: 'center'
        },
        { title: '订单可叫料数量', dataIndex: 'canCallQty', width: 90, align: 'center' },
        {
          title: '叫料数量',
          dataIndex: 'callQty',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'callQty' },
          type: "inputNumber"
        }
      ]
    }
  },
  methods: {
    disabledDate(current) {
      return current && current < this.$moment().startOf('day')
    },
    // 确认创建
    onSubmit () {
      // 交期和数量都填了值的，才作为入参
      const params = this.formData.infos.filter(item => item.callExpectedDeliveryDate && (item.callQty === 0 || !!item.callQty))
      if(params?.length < 1) {
        this.$message.error('请填写数据')
        return false
      }
      this.loading = true;
      apiMesQueryTradeOrderCreate(params).then(res => {
        if (res?.code === 200) {
          this.$message.success('新增成功')
          this.onClose()
          this.$emit('closeModal')
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    onClose() {
      this.resetQuery()
      this.modal = false
    },
    // 初始化查询
    show(organizationCode) {
      this.organizationCode = organizationCode
      this.resetQuery()
      this.formData.infos = []
      this.modal = true
    },
    // 重置按钮操作
    resetQuery () {
      this.formData.infos = []
      this.queryParams = {
        itemCode: undefined,
        tradeOrder: undefined,
        orderExpectedDeliveryDate: undefined,
        orderExpectedDeliveryDateStart: undefined,
        orderExpectedDeliveryDateEnd: undefined
      }
      // this.onSearch()
    },
    // 表单搜索
    onSearch (value = {}) {
      if(!value?.itemCode) {
        this.$message.error('请输入物料编码')
        return
      }
      this.currentId = ''
      this.formData.infos = []
      this.tableLoading = true;
      this.loading = true;
      const params = Object.assign({}, this.queryParams, value)
      params.organizationCode = this.organizationCode
      delete params.searchFormLabel
      apiMesQueryTradeOrderFromScmSingle(params).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          this.formData.infos = res.data
        }
      }).finally(() => {
        this.tableLoading = false;
        this.loading = false;
      })
    }
  },
  mounted () {
    this.loading = false;
    this.tableLoading = false;
  }
}
</script>

<style lang="less" scoped>
.orderMaterialTable{
  /deep/ .ant-form-item{
    margin-bottom: 0;
  }
  /deep/ .ant-form-explain, .ant-form-extra{
    min-height: 0;
    height: 0;
  }
}

</style>
